import React from 'react';

import ReactComponent  from 'assets/icons/trash.svg?react';

const Icon = props => {
    return <ReactComponent {...props} />;
};

export default Icon;